class Address {
  constructor(data) {
    if (data) {
      this.CountryId = data.CountryId;
      this.CityId = data.CityId;
      this.StateId = data.StateId;
      this.AddressDetails = data.AddressDetails;
    } else {
      this.CountryId = null;
      this.CityId = null;
      this.StateId = null;
      this.AddressDetails = null;
    }
  }
}

export default Address;
